import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHintALLOption } from '@capacitor/barcode-scanner';

@Component({
    selector: 'app-scan-camera',
    templateUrl: './scan-camera.page.html',
    styleUrls: ['./scan-camera.page.scss'],
    standalone: false
})
export class ScanCameraPage implements OnInit {

    constructor(
        public viewCtrl: ModalController,
    ) { }

    ngOnInit() {
    }

    async ionViewWillEnter() {
        try {
            const result = await CapacitorBarcodeScanner.scanBarcode({
                hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
                scanInstructions: 'Scan a barcode',
                scanButton: false,
                scanText: 'Scanning...'
            });
            
            if (result.ScanResult) {
                this.viewCtrl.dismiss({code: result.ScanResult});
            } else {
                this.viewCtrl.dismiss();
            }
        } catch (error) {
            console.error('Barcode scan error:', error);
            this.viewCtrl.dismiss();
        }
    }

    ionViewWillLeave() {
        // Clean up if needed
    }

    doCancel() {
        this.viewCtrl.dismiss();
    }
}
